/* eslint-disable */
import $ from 'jquery';
import pageContext from '@bingads-webui-static-legacy/page-context';
var excelFileName = 'EXCEL_Conversion_Import_Template.xlsx';
var csvFileName = 'CSV_Conversion_Import_Template.csv';
function getFileUrl(filename) {
  return pageContext.TemplatesPathUrl + 'Import/' + filename;
}
;
export default {
  excelFileUrl: getFileUrl(excelFileName),
  csvFileUrl: getFileUrl(csvFileName)
};

